import { useQuery } from '@apollo/react-hooks';

import { SYLLABUS_MODE } from 'Domains/syllabus';
import { getCourseCodeReport, getTKCourseCodeReport } from 'GraphQL/queries/report.query';

const CourseCodeData = ({ value, schoolCode, children }) => {
  const { term, grade, classNo, subject, syllabus, lesson, mode } = value;

  const variables = {
    schoolTermId: term,
    schoolGradeId: grade,
    classNo,
    subjectId: subject,
    courseCode: syllabus,
    sectionCode: lesson !== `all-lesson-selected` ? lesson : null,
    schoolCode,
  };

  const isSkip = !term || !grade || !classNo || !subject || !syllabus || !lesson || !schoolCode;

  const traditionalReport = useQuery(getCourseCodeReport, {
    variables: variables,
    skip: isSkip || mode === SYLLABUS_MODE.TUNGKAI,
    notifyOnNetworkStatusChange: true,
  });

  const tungkaiReport = useQuery(getTKCourseCodeReport, {
    variables: variables,
    skip: isSkip || mode === SYLLABUS_MODE.TRADITIONAL,
    notifyOnNetworkStatusChange: true,
  });

  const report = mode === SYLLABUS_MODE.TRADITIONAL ? traditionalReport : tungkaiReport;

  const { loading, error, data, refetch, networkStatus } = report;
  return children({ loading, error, data, refetch, networkStatus });
};

export default CourseCodeData;
